var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.bgImageStyle }, [
    _c("div", { staticClass: "try-outfit" }, [
      _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("div", { staticClass: "subtext" }, [_vm._v(_vm._s(_vm.subtext))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-735808c9", { render: render, staticRenderFns: staticRenderFns })
  }
}